import { StackView, Text, Logo, Input, Divider } from '@planningcenter/tapestry-react';
import React, { useState } from 'react';
import 'stream-chat-react';
import '@planningcenter/datetime-fmt';
import '../../_virtual/moment.js';
import { useChat } from '../hooks/use_chat.js';
import { useChatApi } from '../hooks/use_chat_api.js';
import '@planningcenter/url';
import '@planningcenter/jolt-client';
import 'stream-chat';
import { ErrorCard } from './ui/error_card.js';
import { People } from './groups/people.js';
import { NewChatViewFooter } from './new_chat_view/footer.js';
import { NewChatViewHeader } from './new_chat_view/header.js';

const NewGroupsChatView = () => {
    var _a;
    const [title, setTitle] = useState("");
    const [isCreating, setIsCreating] = useState(false);
    const [isError, setIsError] = useState(false);
    const api = useChatApi();
    const { filterValues, navigation } = useChat();
    const group = (_a = filterValues === null || filterValues === undefined ? undefined : filterValues.Groups) === null || _a === undefined ? undefined : _a.group;
    if (!group)
        return null;
    const createConversation = () => {
        setIsCreating(true);
        return api.groups
            .post(`me/groups/${group.id}/chat_conversation_payload`, { title })
            .then(({ value: payload }) => api.chat.post("me/conversations", { payload }))
            .catch(() => setIsError(true))
            .finally(() => setIsCreating(false));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(NewChatViewHeader, null),
        React.createElement(StackView, { grow: 1 },
            React.createElement(StackView, { spacing: 2, padding: 2, paddingTop: 0 },
                React.createElement(StackView, { axis: "horizontal", alignment: "center", spacing: 1 },
                    React.createElement(Text, { weight: 600 }, "To:"),
                    React.createElement(Logo, { name: "groups", markOnly: true, size: "20px", theme: "color" }),
                    React.createElement(Text, { wrap: false, truncate: true }, group.name)),
                React.createElement(StackView, { spacing: 1 },
                    React.createElement(Input.InputLabel, { controls: "title" }, "Title"),
                    React.createElement(Input, { id: "title", placeholder: "Topic of conversation... (required)", required: true, onChange: (e) => setTitle(e.target.value) }))),
            React.createElement(Divider, null),
            React.createElement(StackView, { grow: 1, padding: 2, paddingBottom: 0, spacing: 1 },
                React.createElement(People, { groupId: group.id }))),
        isError && (React.createElement(ErrorCard, { marginBottom: 2, marginHorizontal: 2, message: "There was an issue starting the conversation, please try again." })),
        React.createElement(NewChatViewFooter, { text: "Conversation will be automatically updated if any people are added or removed from the group.", showSpinner: isCreating, buttonDisabled: title.trim().length === 0, onButtonClick: () => createConversation()
                .then(({ stream_channel_id: id }) => navigation.switchToChannelView(id))
                .then(() => setTitle("")) })));
};

export { NewGroupsChatView };
//# sourceMappingURL=new_groups_chat_view.js.map
